// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___SO95j","root__cover":"style-module__root__cover___gPwxj","root__wrapper":"style-module__root__wrapper___Lefro","root__actions":"style-module__root__actions___HlSmV","root__profile":"style-module__root__profile___XYLw7"};
    if(module.hot) {
      // 1697460464231
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  